import { Link } from 'react-router-dom';
import { ErrorBoundary } from '../components/common/ErrorBoundary';
import { Header } from '../components/layout/Header';

export function PleaseVerifyEmailPage() {
  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-gray-50">
        <Header hideSignInButton={true} />
        <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-md w-full space-y-8 text-center">
            <div>
              <div className="flex items-center justify-center mb-6">
                <svg className="h-16 w-16 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Please Verify Your Email
              </h2>
              <p className="text-gray-600 mb-6 leading-relaxed">
                You need to verify your email address to complete the sign-up process. A verification link has been sent to your email. Make sure to check your spam/junk email folder.
              </p>
              <div className="space-y-4">
                <Link
                  to="/"
                  className="btn btn-primary w-full"
                >
                  Back to Home
                </Link>
                <Link
                  to="/login"
                  className="btn btn-outline w-full"
                >
                  Go to Login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
}
